export const dateEvent = [
  {
    date: '14 January, 2021',
    event: 'Makar Sankranti (Snan)'
  },
  {
    date: '11 February , 2021',
    event: 'Mauni Amavasya (Snan)'
  },
  {
    date: '16 February, 2021',
    event: 'Basant Panchami (Snan)'
  },
  {
    date: '27 February, 2021',
    event: 'Magh Poornima'
  },
  {
    date: '11 March , 2021',
    event: 'Maha Shivratri (Shahi Snan)'
  },
  {
    date: '28 March, 2021',
    event: 'Falgun Purnima (Shahi Snan)'
  },
  {
    date: '12 April, 2021',
    event: 'Somvati Amavasya (Shahi Snan)'
  },
  {
    date: '14 April , 2021',
    event: 'Baisakhi (Shahi Snan)'
  },
  {
    date: '21 April , 2021',
    event: 'Ram Navami (Snan)'
  },
  {
    date: '27 April , 2021',
    event: 'Chaitra Purnima (Shahi Snan)'
  }
];

export const kumbhMelaLocations = [
  'Haridwar on the Ganges in Uttarakhand.',
  'Ujjain on the Shipra in Madhya Pradesh.',
  'Nashik on the Godavari in Maharashtra.',
  'Prayagraj at the confluence of the Ganges, the Yamuna, and the mythical Sarasvati in Uttar Pradesh.'
];

export const kumbhMelaInfo = [
  {
    title: '',
    html: '<span class="blackText latoBold">Kumbh Mela Trains 2021</span> - Take a look at the latest Kumbh mela special trains list 2021 prepared by the Indian Railways to make travel easy for pilgrims. You may use this list for the Kumbh Mela Train Booking and join the largest congregation of sadhvis, saints, pilgrims, sadhus &amp; other devotees in Haridwar from 14th January till April 27, 2021. The Indian railways Kumbh Mela 2021 special trains have started running on Makar Sankranti, January 14. These special trains for Kumbh mela are operating on many routes for tourists &amp; devotees to reach Haridwar for the most celebrated and oldest religious festival. The railway stations have been cleaned to run Kumbh mela special trains to Haridwar.'
  },
  {
    title: 'Here are the few Covid-19 Guidelines to follow for Kumbh Mela 2021:',
    html: `<p class="appendBottom5">Commuters are advised to check these Covid-19 safety guidelines after checking the Kumbh Mela trains list. Uttarakhand State Disaster Response Force (SDRF) launched a campaign to aware the devotees &amp; tourists for Covid-19. All devotees need to register themselves first, to attend the biggest religious event in India.</p>
        <p>During the Kumbh mela, a rapid antigen test is conducted for every devotee to keep all the safety measures of Covid-19 in mind. Not only this, thermal screening at every entrance is mandatory for everyone coming from bus and Kumbh mela special trains before starting their journey to Haridwar. Though the devotees are provided with free masks, they aren’t allowed to enter the ghat without one. The pilgrims are also supposed to register themselves online for four snans (an important part of the festival is to take a dip in the holy river Ganges). Commuters shall see the Kumbh mela trains list here to easily commute to the holy destination.</p>`
  },
  {
    title: 'Important Kumbh Mela 2021 Dates:',
    html: `<table class="" style="width: 100%; text-align: center; border: 1px solid lightgrey; background-color: rgb(250, 250, 248);">
        <thead>
           <tr>
              <th style="border: 1px solid lightgrey; width: 50%;">
                 <p class="padding10"><span style="color: rgb(0, 100, 0);"><strong>Dates</strong></span></p>
              </th>
              <th style="border: 1px solid lightgrey; width: 50%;">
                 <p class="padding10"><span style="color: rgb(0, 100, 0);"><strong>Events</strong></span></p>
              </th>
           </tr>
        </thead>
        <tbody style="width: 100%;">
        ${dateEvent
          .map(
            ({ date, event }) =>
              `<tr>
            <td style="border: 1px solid lightgrey; width: 50%;">
               <p class="padding10">${date}</p>
            </td>
            <td style="border: 1px solid lightgrey; width: 50%;">
               <p class="padding10">${event}</p>
            </td>
         </tr>`
          )
          .join('')}
        </tbody>
     </table>`
  },
  {
    title: 'The Mela site keep changing to four locations across the country:',
    html: `<ul class="paddingL20 darkGreyText" style="list-style: disc;">
        ${kumbhMelaLocations
          .map((location) => {
            return `<li class="appendBottom5">${location}</li>`;
          })
          .join('')}
        </ul>`
  },
  {
    title: 'List of Kumbh Mela Trains 2021',
    html: '<p class="darkGreyText">Take a look at the Kumbh Mela special train list</p>'
  }
];
